import countryCodeEmoji from 'country-code-emoji';
import * as EmailValidator from 'email-validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { isNil } from 'lodash';

export class MBAuthUtil {
  static isEmail(email?: string): boolean {
    if (isNil(email)) {
      return false;
    }
    return EmailValidator.validate(email);
  }

  static isPhoneNumber(phoneNumber?: string): boolean {
    if (isNil(phoneNumber)) {
      return false;
    }
    const parsed = parsePhoneNumberFromString(phoneNumber, 'US');
    return !!parsed && parsed.isValid();
  }

  static isPossiblePhoneNumber(phoneNumber?: string): boolean {
    // Check if this is likely to be a phone number before displaying emoji flags
    if (isNil(phoneNumber)) {
      return false;
    }
    // If the phone number is already valid, return true
    if (MBAuthUtil.isPhoneNumber(phoneNumber)) {
      return true;
    }
    const longerThan = phoneNumber.length > 4;
    const phoneNumberMatch = !!phoneNumber.match('^[\\d*#+ ]+$');
    const noAtoZ = !phoneNumber.match('.*[a-zA-Z]+.*');
    return longerThan && phoneNumberMatch && noAtoZ;
  }

  static getEmojiFlagFromPhone(phoneNumber: string): string | boolean {
    if (!MBAuthUtil.isPossiblePhoneNumber(phoneNumber)) {
      return false;
    }
    const parsed = parsePhoneNumberFromString(phoneNumber, 'US');
    if (parsed && parsed.country) {
      return countryCodeEmoji(parsed.country);
    }
    return false;
  }

  static getInternationalNumber(phoneNumber: string) {
    // Get E164 number if possible, otherwise failback to national number
    if (!MBAuthUtil.isPossiblePhoneNumber(phoneNumber)) {
      return phoneNumber;
    }
    const parsed = parsePhoneNumberFromString(phoneNumber, 'US');
    if (parsed && parsed.number) {
      return parsed.number;
    }
    return phoneNumber;
  }

  static getAuthToken(): string | null | undefined {
    return localStorage.getItem('authToken');
  }

  static getBizAuthToken(): string | null | undefined {
    return localStorage.getItem('authBizToken');
  }
}
